import { render } from "./Snapshot.vue?vue&type=template&id=20cb8bfe&scoped=true"
import script from "./Snapshot.vue?vue&type=script&lang=js"
export * from "./Snapshot.vue?vue&type=script&lang=js"

import "./Snapshot.vue?vue&type=style&index=0&id=20cb8bfe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cb8bfe"]])

export default __exports__